var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardTimelineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.003,
    viewBox: "0 0 27 27.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.755,25.5a4.5,4.5,0,0,1,8.49,0H30L31.5,27,30,28.5H22.245a4.5,4.5,0,0,1-8.49,0H4.5L6,27,4.5,25.5ZM18,28.5A1.5,1.5,0,1,0,16.5,27,1.5,1.5,0,0,0,18,28.5ZM21,18l-3,3-3-3H10.5a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3h15a3,3,0,0,1,3,3V15a3,3,0,0,1-3,3ZM10.5,7.5V15h6L18,16.5,19.5,15h6V7.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#2cccd3",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTimelineIcon);
export default __webpack_public_path__ + "static/media/dashboard-timeline-icon.572aedcd.svg";
export { ForwardRef as ReactComponent };